module.exports = {
  nonWriteoffList: 'Список несписанных',
  writeoffList: 'Поиск списаний',
  selectHedgingTheInvoice: 'Пожалуйста, выберите счет для хеджирования',
  return: 'Назад',
  query: 'Поиск',
  writeOffs: 'Списание',
  confirm: 'Подтвердить',
  hedgingWriteOffs: 'Хеджирование списаний',
  actualReceiptAndPayment: 'Фактическое получение и оплата',
  revenueAndExpenditureMethod: 'Метод получения и оплаты',
  all: 'Все',
  receivables: 'Дебиторская задолженность',
  payables: 'Кредиторская задолженность',
  feeType: 'Тип сбора:',
  domestic: 'Внутренний',
  international: 'Международный',
  writeOffMode: 'Режим списания',
  charges: 'Сборы',
  invoice: 'Счет',
  bill: 'Счет-фактура',
  accountStatement: 'Выписка по счету',
  paymentRequest: 'Запрос на оплату',
  revenueAndExpenditureDate: 'Дата получения/оплаты',
  writeOffSerialNumber: 'Серийный номер списания',
  settleAccountsTo: 'Объект расчета',
  chargeRemark: 'Примечание к сбору',
  applyState: 'Статус заявки',
  applicationNo: 'Номер заявки',
  businessNumber: 'Номер операции',
  theOppositeSideInvoiceNo: 'Номер счета контрагента',
  consignationCompany: 'Компания-отправитель',
  settlementAgent: 'Расчетный агент',
  currency: 'Валюта',
  applicant: 'Заявитель',
  businessType: 'Тип операции',
  dateOfApplication: 'Дата заявки',
  businessDate: 'Дата операции',
  operation: 'Операция',
  sales: 'Продажи',
  wroteOffOrNot: 'Списано или нет',
  businessReferenceNumber: 'Справочный номер операции',
  businessStatus: 'Статус операции',
  separateNumber: 'Номер разделения',
  paymentNotificationNo: 'Номер уведомления об оплате',
  applicationDepartment: 'Отдел-заявитель',
  paymentPeriod: 'Срок оплаты',
  amount: 'Сумма',
  theAmountOfWriteOffs: 'Сумма списания',
  approvalStatus: 'Статус одобрения',
  businessAuditor: 'Бизнес-аудитор',
  businessAuditDate: 'Дата бизнес-аудита',
  departmentAuditor: 'Аудитор отдела',
  departmentAuditDate: 'Дата аудита отдела',
  officeAuditor: 'Офисный аудитор',
  officeAuditDate: 'Дата офисного аудита',
  financialAuditor: 'Финансовый аудитор',
  financialAuditDate: 'Дата финансового аудита',
  financeVerifyDate: 'Дата финансовой проверки',
  verificationStatus: 'Статус проверки',
  remark: 'Примечание',
  totalAmountNtWrittenOff: 'Общая сумма несписанных',
  methodOfPayment: 'Способ оплаты',
  claimState: 'Статус требования',
  prePayment: 'Предоплата',
  lastTimeBalance: 'Последний баланс',
  thisTimeWriteOff: 'Текущее списание',
  thisTimeBalance: 'Текущий баланс',
  otherCurrency: 'Другая валюта',
  paymentMethod: 'Способ получения платежа',
  bankReceiptStatus: 'Статус банковской квитанции',
  ourSideBank: 'Наш банк',
  ourSideAccount: 'Наш счет',
  proofNo: 'Номер подтверждения',
  usePaymentRecord: 'Использовать запись об оплате',
  paymentAmount: 'Сумма оплаты',
  receiptAmount: 'Сумма получения',
  theOppositeSideCompany: 'Компания-контрагент',
  theOppositeSideBank: 'Банк контрагента',
  theOppositeSideAccount: 'Счет контрагента',
  exchangeGainsAndLosses: 'Курсовые разницы',
  financialCharges: 'Финансовые расходы',
  oddment: 'Остаток',
  originalCurrencyExchangeDifference: 'Курсовая разница в исходной валюте',
  writeOffRemarks: 'Примечания к списанию',
  paymentReceivedDate: 'Дата получения платежа',
  paymentDate: 'Дата оплаты',
  confirmToWriteOff: 'Подтвердить списание',
  cancel: 'Отмена',
  totalGainsAndLosses: 'Общие прибыли и убытки',
  date: 'Дата',
  method: 'Метод',
  use: 'Использовать',
  cancelUsed: 'Отменить использование',
  record: 'Запись',
  chargeItem: 'Наименование сбора',
  reconciliationStatus: 'Статус сверки',
  type: 'Тип',
  writeOffExchangeRate: 'Курс списания',
  total: 'Итого',
  confirmedCharge: 'Подтвержденный сбор',
  subTotal: 'Промежуточный итог',
  invoiceNo: 'Номер счета',
  invoiceHeader: 'Заголовок счета',
  invoiceDate: 'Дата выставления счета',
  revenueAndExpenditureType: 'Тип получения/оплаты',
  billNo: 'Номер счета-фактуры',
  accountStatementNo: 'Номер выписки',
  billType: 'Тип счета-фактуры',
  useReceiptRecord: 'Использовать запись о получении',
  cancelUsedReceiptRecord: 'Отменить использование записи о получении',
  cancelUsedPaymentRecord: 'Отменить использование записи об оплате',
  mbl: 'Номер основного коносамента',
  itemNo: 'Номер позиции',
  bankReceiptNo: 'Номер банковской квитанции',
  settlementCompany: 'Расчетная компания',
  solicitationType: 'Тип привлечения',
  writeOffPerson: 'Лицо, выполнившее списание',
  amountRange: 'Диапазон суммы',
  writeOffDate: 'Дата списания',
  RecheckDate: 'Дата повторной проверки',
  advanceMoneyOrNot: 'Авансовый платеж',
  recheckOrNot: 'Повторная проверка',
  proofOrNot: 'Создание подтверждения',
  proofDate: 'Дата подтверждения',
  paymentType: 'Тип платежа',
  prepaidOrNot: 'Предоплата',
  theAmountOfWrittenOff: 'Сумма списанного',
  balance: 'Баланс',
  actualReceiptAmount: 'Фактическая сумма получения',
  actualPaymentAmount: 'Фактическая сумма оплаты',
  creator: 'Создатель',
  recheck: 'Повторная проверка',
  invalid: 'Недействительный',
  invoicingInformation: 'Информация о выставлении счета',
  unchecked: 'Снять выделение',
  writeOffCurrency: 'Валюта списания',
  chargeOriginalCurrency: 'Исходная валюта сбора',
  chargeOriginalAmount: 'Исходная сумма сбора',
  chargeOriginalExchangeRate: 'Исходный курс сбора',
  rmbAmount: 'Юань',
  usdAmount: 'Доллар США',
  cancelRecheck: 'Отменить повторную проверку',
  editWriteOff: 'Редактировать списание',
  cancelWriteOff: 'Отменить списание',
  viewDetails: 'Просмотр деталей',
  exportExcel: 'Экспорт в Excel',
  proof: 'Подтверждение',
  refreshRate: 'Обновить курс',
  refreshActualReceiptAndPaymentAmount: 'Обновить фактические суммы получения и оплаты',
  writeOffType: 'Тип списания',
  vesselVoyage: 'Судно/Рейс',
  containerSizeAmount: 'Размер/Количество контейнеров',
  monetaryEquivalent: 'Денежный эквивалент',
  customerService: 'Обслуживание клиентов',
  totalWriteOffs: 'Общее списание',
  totalEquivalent: 'Общий эквивалент',
  exportToExcel: 'Экспорт в Excel',
  exportPDF: 'Экспорт в PDF',
  print: 'Печать',
  close: 'Закрыть',
  dayOfCreditTerm: 'Срок кредита (дней)',
  billPaymentNo: 'Номер платежного поручения',
  totalCurrency: 'Итого по валютам',
  rateBy: 'Курс списания',
  rateByInvoice: 'По курсу счета',
  rateByAverage: 'По среднему курсу',
  businessCreateDate: 'Дата создания операции',
  invoicingStatus: 'Статус выставления счета',
  searchReqCondition: 'Необходимо выбрать хотя бы одно условие поиска',
  dateTo: 'До',
  lockCheckBoxDate: 'Поиск данных старше двух лет',
  queryLotsOfData: 'Поиск данных старше двух лет',
  writeOffDateNotEmpty: 'Дата списания не может быть пустой!',
  unlockWriteOffDateQuery: 'Если выбранный диапазон дат списания превышает 2 года, это может повлиять на скорость загрузки данных. Вы уверены, что хотите искать данные старше двух лет?',
  voucherNo: 'Номер ваучера',
  voucherCreateDate: 'Дата создания ваучера',
  chargeSettleAccountsTo: 'Объект расчета сбора',
  update: 'Обновить',
  strip: 'шт.',
  targetVoucherNo: 'Номер ваучера контрагента',
  voucherDate: 'Дата ваучера 2',
  sourceRateDiff: 'Курсовая разница в исходной валюте',
  warehouseNo: 'Номер склада',
  userDefinedField1: 'Пользовательское поле 1',
  userDefinedField2: 'Пользовательское поле 2',
  userDefinedField3: 'Пользовательское поле 3',
  havingInvoiceingNoOrNot: 'Наличие номера счета',
  selectActualReceiptAndPayment: 'Выбрать фактическое получение и оплату',
  noCurrencyRate: 'Не найден курс для валюты {0}, пожалуйста, своевременно обновите соответствующие курсы!',
  selectMethodOfPayment: 'Пожалуйста, выберите способ оплаты.',
  selectOurSideBank: 'Пожалуйста, выберите наш банк.',
  rateByCharge: 'По курсу сбора',
  preExchangeDifference: 'Предварительная курсовая разница',
  bankWaterNo: 'Номер банковской квитанции',
  ReceivableSoldAmount: 'Списано по дебиторской задолженности',
  PayableSoldAmount: 'Списано по кредиторской задолженности',
  ActualAmountReceivable: 'Фактическая сумма дебиторской задолженности',
  ActualAmountPayable: 'Фактическая сумма кредиторской задолженности',
  ChargeOriginTotalAmount: 'Исходная общая сумма сбора',
  FinancialExpensesBeAllocated: 'Распределение финансовых расходов',
  FinanceExpensesAllocation: 'Распределение финансовых расходов',
  ChargingDirection: 'Направление сбора',
  SelectChargeItem: 'Пожалуйста, выберите статью сбора',
  SelectAccountObject: 'Пожалуйста, выберите расчетную единицу',
  FinanceChargeShareJobTip: 'При отмеченном флажке финансовые расходы будут автоматически распределены поровну между всеми операциями при списании',
  NotSyncCannotModify: 'Данные, синхронизированные с облачной платформой, не могут быть изменены или отменены!',
  invoiceTitle: 'Invoice Title',
  writeoffMatchStatus: 'Match Status',
  matchStatusUnmatched: 'Unmatched',
  matchStatusAuto: 'Auto Written Off',
  matchStatusManual: 'Manual Write-off',
  matchStatusNoNeed: 'No Need Write-off',
  matchStatusReason: 'Reason for Status Change',
  writeoffSeqNoSource: 'Serial No. Source',
  sourceImport: 'Import',
  sourceSystem: 'System',
  modifyMatchStatus: 'Modify Match Status',
  modifyStatus: 'Modify Status',
  modifyReason: 'Reason',
  confirmModify: 'Confirm',
  modifySuccess: 'Successfully modified {0} records',
  lockedCannotModify: 'Locked, cannot modify',
  containsLockedStatus: 'Contains locked status, please select unmatched records',
  pleaseSelectUnmatched: 'Please select unmatched records',
  selectAtLeastOne: 'Please select at least one record'
}
